<template>
  <div class="v-text-field">
    <span v-if="label" v-text="label" />
    <input
      v-model="text"
      :placeholder="placeholder"
      :type="type"
      :class="computedClass"
      :disabled="disabled"
    />
    <span v-text="error" class="error-text" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";

export interface Props {
  disabled?: boolean;
  error?: string;
  label?: string;
  modelValue?: string | number;
  placeholder?: string;
  type?: string;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  type: "text",
});

const emit = defineEmits<{
  (e: "update:modelValue", value: string | number): void;
}>();

const text = ref(props.modelValue);

const computedClass: string = computed(() => {
  return props.error
    ? ["text-field-input", "error-border"].join(" ")
    : "text-field-input";
});

watch(
  () => props.modelValue,
  (newValue: string | number) => {
    text.value = newValue;
  },
);

watch(text, (newValue: string | number) => {
  text.value = newValue;
  emit("update:modelValue", newValue);
});
</script>

<style lang="scss" scoped>
.text-field-input {
  border: 1px solid rgb(204, 206, 209);
  border-radius: 2px;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0.9em;
  width: 100%;
  margin: 0;
}

.error-border {
  border: 1px solid #ff0000;
}

.error-text {
  color: #ff0000;
}
</style>
